<script>
   
    
</script>


<main>

    
   <div class='imgtext'>
      <div>Coed-Y-Brenin</div>
      <a href="https://www.mbwales.com/agents/coed-y-brenin/" target="_blank">
      <img src='/images/todo/coed-y-brenin.jpg' alt='coed-y-brenin' />
      </a>
  </div>
  
  <div class='imgtext'>
      <div>Barmouth & beach</div>
      <a href="https://www.visitwales.com/attraction/beach/barmouth-beach-1959973" target="_blank">
  <img src='/images/todo/barmouth.jpg' alt='barmouth' />
  </a>
  </div>
  
  <div class='imgtext'>
      <div>Centre for Alternative Technology</div>
      <a href="https://cat.org.uk/" target="_blank">
  <img src='/images/todo/cat.jpg' alt='cat' />
  </a>
  </div>
  
  <div class='imgtext'>
      <div>Cader Idris</div>
      <a href="https://www.snowdoniaguide.com/cader_idris.html" target="_blank">
  <img src='/images/todo/cader_idris.jpg' alt='cader idris' />
  </a>
  </div>
  <div class='imgtext'>
      <div>Ffestniog Railway</div>
      <a href="https://www.festrail.co.uk/" target="_blank">
      <img src='/images/todo/ffestiniog-railway.jpeg' alt='ffestiniog railway' />
      </a>
  </div>
  
  <div class='imgtext'>
      <div>Golf</div>
      <a href="https://www.royalstdavids.co.uk/" target="_blank">
  <img src='/images/todo/golf.webp' alt='barmouth golf' />
  </a>
  </div>
  
  <div class='imgtext'>
      <div>Harlech Castle</div>
      <a href="https://www.visitwales.com/attraction/castle/harlech-castle-cadw-1834662" target="_blank">
  <img src='/images/todo/harlech-castle.jpg' alt='Harlech castle' />
  </a>
  </div>
  
  <div class='imgtext'>
      <div>White Water Rafting and Canoeing</div>
      <a href="https://www.balawatersports.com/" target="_blank">
      <img src='/images/todo/whitewater-rafting.jpg' alt='White Water Rafting and Canoeing' />
      </a>
  </div>
  
  <div class='imgtext'>
      <div>New Precipice Walk</div>
      <a href="https://mawddachestuary.co.uk/" target="_blank">
      <img src='/images/todo/new-precipice-walk.jpg' alt='New precipicewalk' />
      </a>
  </div>
  
  <div class='imgtext'>
      <div>King Arthur's Labyrinth</div>
      <a href="https://www.mbwales.com/agents/coed-y-brenin/" target="_blank">
      <img src='/images/todo/king-arthur.jpg' alt='King Arthurs Labyrinth' />
      </a>
  </div>


</main>

<style>
 main{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 60vw;
    text-align: center;
    margin: auto;
 }   
 .imgtext{
    width: 45%;
    padding:5px;
    border-width: 10px;
    border-style: double;
   overflow: hidden;
    height: 300px;
 }
 img{
    width: 100%;
    height: 100%;
 }
 .imgtext:hover{
    border-color: aqua;
    cursor: pointer;
 }
 @media screen and (max-width: 1220px) {
    main {
      width: 80%;
      text-align: center;
      margin: auto;
    }
  }
  @media screen and (max-width: 800px) {
    main {
      width: 100%;
      text-align: center;
      margin: auto;
      padding-top:50px;
    }
    .imgtext{
    width: 100%;
    }
    img{
        padding-top: 10px;
        padding-bottom: 10px;
    }
  }
</style>